import { BaseModel } from '@model/BaseModel';
import { BrandType } from '@model/Brand';
import { DeliveryType } from '@model/Delivery';
import { ItemSpecification } from '@model/ItemSpecification';
import { PackageType } from '@model/Package';
import { SkuType } from '@model/Sku';
import { ShippingMethodType } from './ShippingMethod';

export enum ORDER_ITEM_STATUS {
    PENDING = 'new',
    UNSHIPPED = 'unshipped',
    PARTIALLY_SHIPPED = 'partially_shipped',
    SHIPPED = 'shipped',
    CANCELLED = 'cancelled',
    DELIVERED = 'delivered',
}

export class OrderItem extends BaseModel {
    public sku!: SkuType;
    public id!: number;
    public name!: string;
    public notes!: string;
    public image_id!: number;
    public image!: any;
    public sku_id!: number;
    public package_id!: number;
    public package!: PackageType;
    public order_id!: number;
    public item_specifications!: ItemSpecification[];
    public spec_sizeable!: boolean;
    public spec_nameable!: boolean;
    public spec_numberable!: boolean;
    public design_allow_lowercase!: boolean;
    public design_nameable!: boolean;
    public design_numberable!: boolean;
    public item_specifications_submitted: boolean;
    public spec_allow_lowercase!: boolean;
    public documents!: any[];
    public document_ids!: any[];
    public quantity!: number;
    public delivery!: DeliveryType;
    public purchased!: boolean;
    public tracking_number!: boolean;
    public approved_designs!: BaseModel[];
    public miscellaneous_designs!: BaseModel[];
    public marketplace_listed!: number;
    public shipment_details!: any[];
    public shipping_details!: any[];
    public status!: string;
    public brand!: BrandType;
    public vendor: any;
    public is_shipped: boolean;
    public price_single: number;
    public category_id: number;
    public subcategory_id: number;
    public shipping_method_id: number;
    public shipping_method: ShippingMethodType;
    public product_shipping_methods: ShippingMethodType[];
    public is_shipping_method_available: boolean;
    public package_uuid: string | null;
    public vendor_order_item: any;
    public addons: any[];
    public expected_delivery_date: Date;
    public price: any;
    public is_division_enabled: boolean;
    public divisions: any;
}
